//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CategoriesComponent',
  components: {
    Scroller: () => import('@/components/common/Scroller'),
    PlaceCard: () => import('@/components/common/PlaceCard'),
    SliderWithBullets: () => import('@/components/common/SliderWithBullets')
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    key () {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < 10; i++) {
        result += characters.charAt(Math.floor(Math.random() *
          charactersLength))
      }
      return result
    },
    show () {
      return this?.categories?.places?.length > 0
    }
  }
}
